import { useEffect, useState } from "react";
import { toast } from "sonner";
import { adminOrders, adminResendOrder, adminGetSettings, adminUpdateSettings, apiError, formatMoney } from "@/lib/api";
import { AdminHeader, PrimaryBtn, fieldCls, labelCls } from "./ui";
import AdminOffers from "./AdminOffers";

const FIELDS = [["factura_razon_social", "Razón social"], ["factura_direccion", "Dirección"], ["factura_cif", "CIF / Nº fiscal"]];

function InvoiceData() {
  const [s, setS] = useState(null);
  useEffect(() => { adminGetSettings().then(setS); }, []);
  if (!s) return null;
  const save = async (e) => {
    e.preventDefault();
    try { await adminUpdateSettings(Object.fromEntries(FIELDS.map(([k]) => [k, s[k]]))); toast.success("Datos de factura guardados."); }
    catch (err) { toast.error(apiError(err)); }
  };
  return (
    <form onSubmit={save} className="rounded-xl bg-white border border-[#0f2544]/8 p-5 space-y-3" data-testid="invoice-data-form">
      <h2 className="font-serif text-xl text-[#0f2544]">Datos de la factura</h2>
      {FIELDS.map(([k, l]) => (
        <div key={k}><label className={labelCls}>{l}</label><input value={s[k] || ""} onChange={(e) => setS({ ...s, [k]: e.target.value })} className={fieldCls} data-testid={`invoice-${k}`} /></div>
      ))}
      <PrimaryBtn type="submit" testId="save-invoice-data">Guardar</PrimaryBtn>
    </form>
  );
}

export default function AdminVentas() {
  const [orders, setOrders] = useState([]);
  useEffect(() => { adminOrders().then(setOrders); }, []);
  const paid = orders.filter((o) => o.status === "PAGADO");
  const resend = async (o) => {
    try { await adminResendOrder(o.id); toast.success("Email reenviado."); adminOrders().then(setOrders); }
    catch (err) { toast.error(apiError(err)); }
  };

  return (
    <div className="space-y-10">
      <AdminHeader title="Ventas" subtitle={`${paid.length} venta(s) de ebooks`} />
      <div className="overflow-x-auto rounded-xl bg-white border border-[#0f2544]/8" data-testid="orders-table">
        <table className="w-full text-sm">
          <thead className="text-left text-xs text-[#8a8a83] border-b border-[#0f2544]/8">
            <tr><th className="px-4 py-3">Fecha</th><th className="px-4 py-3">Factura</th><th className="px-4 py-3">Libro</th><th className="px-4 py-3">Cliente</th><th className="px-4 py-3">Total</th><th className="px-4 py-3">Estado</th><th className="px-4 py-3" /></tr>
          </thead>
          <tbody>
            {orders.length === 0 && <tr><td colSpan={7} className="px-4 py-10 text-center text-[#8a8a83]">Aún no hay ventas.</td></tr>}
            {orders.map((o) => (
              <tr key={o.id} className="border-b border-[#0f2544]/5" data-testid={`order-row-${o.id}`}>
                <td className="px-4 py-3 whitespace-nowrap">{(o.paid_at || o.created_at).slice(0, 10)}</td>
                <td className="px-4 py-3">{o.numero_factura || "—"}</td>
                <td className="px-4 py-3">{o.titulo}</td>
                <td className="px-4 py-3">{o.nombre}<div className="text-xs text-[#8a8a83]">{o.email}</div></td>
                <td className="px-4 py-3 whitespace-nowrap">{formatMoney(o.total, o.moneda)}{o.descuento ? <span className="text-xs text-[#1f44e0]"> (-{o.descuento}%)</span> : null}</td>
                <td className="px-4 py-3">{o.status === "PAGADO" ? <span className="text-green-600">Pagado</span> : <span className="text-[#8a8a83]">Sin completar</span>}{o.status === "PAGADO" && o.email_enviado === false && <div className="text-xs text-red-600">Email no enviado</div>}</td>
                <td className="px-4 py-3">{o.status === "PAGADO" && <button onClick={() => resend(o)} className="text-xs text-[#1f44e0] font-semibold whitespace-nowrap" data-testid={`resend-${o.id}`}>Reenviar email</button>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <AdminOffers />
      <InvoiceData />
    </div>
  );
}
